import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/app/config/environments/environment';
import { IntegrationFilterDto } from '../models/dto/integration-filter.dto';
import { Integration } from '../models/interfaces/integration.interface';

@Injectable()
export class IntegrationService {
  constructor(private http: HttpClient) {}

  public get(filter: IntegrationFilterDto): Observable<Integration[]> {
    return this.http.get<Integration[]>(`${environment.api.baseUrl}/integration`,
    { params: this.buildParams(filter) }    
    )
  }

  private buildParams(filter?: IntegrationFilterDto): HttpParams {
    let params = new HttpParams();
    params = filter!.key
      ? params.set('key', filter!.key)
      : params;
    params = filter!.idSchool
        ? params.set('idSchool', filter!.idSchool)
        : params;
    return params;
  }     
}
